import { render, staticRenderFns } from "./Lrjkzw.vue?vue&type=template&id=866f56a2&scoped=true&"
import script from "./Lrjkzw.vue?vue&type=script&lang=js&"
export * from "./Lrjkzw.vue?vue&type=script&lang=js&"
import style0 from "./Lrjkzw.vue?vue&type=style&index=0&id=866f56a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866f56a2",
  null
  
)

export default component.exports